export const SITE_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY ?? "6Ld2zuAhAAAAANb7UEOwBP39jEZF6UfE2_9c6G-j";

export const SECRET_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SECRET_KEY ?? "6Ld2zuAhAAAAANpr2Yk5fZOTkdX5QLiLByIfgSSY";
